import { INotificationsSearchParams } from './types';

export const argumentifyNotificationsSearchParams = ({
  isUnread,
  sorting,
  skipCount,
  maxResultCount,
}: INotificationsSearchParams) => [isUnread, sorting, skipCount, maxResultCount] as const;
